// extracted by mini-css-extract-plugin
module.exports = {"chain":"AddChain_chain__2Ki_3","title":"AddChain_title__1t1s6","subtitle":"AddChain_subtitle__36Lea"};